var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCartWhite = function SvgShoppingCartWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    fillOpacity: 0
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/shopping cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2.309 4.039h.84c1.412 0 2.599 1.095 2.752 2.542l1.516 10.341c.154 1.447 1.34 2.542 2.753 2.542h9.988c1.266 0 3.281-.386 3.858-2.733l2.356-9.737a.56.56 0 0 0-.543-.69H5.86m3.273 18.24h1.038m-1.038 1.07h1.038m11.58-1.07h1.039m-1.038 1.07h1.038m-11.753-.534c0 .787-.62 1.425-1.385 1.425-.764 0-1.384-.638-1.384-1.425 0-.788.62-1.426 1.384-1.426.765 0 1.385.638 1.385 1.426Zm12.619 0c0 .787-.62 1.425-1.385 1.425s-1.384-.638-1.384-1.425c0-.788.62-1.426 1.384-1.426.765 0 1.385.638 1.385 1.426Z"
  }))));
};
export default SvgShoppingCartWhite;